<app-container [bottom]="60" [top]="80">
  <div class="container">
    <div class="row">
      <div class="col-lg-4">
        <ng-container
          [ngTemplateOutlet]="bigBox"
          [ngTemplateOutletContext]="{
            boxTitle: data?.content?.boxTitle,
            boxSubtitle: data?.content?.boxSubtitle,
            boxPhone: data?.content?.boxPhone
          }"
        ></ng-container>
      </div>
      <div class="col-lg-8">
        <div class="row">
          <div class="col-lg-6" *ngFor="let item of data?.content?.schedule">
            <ng-container
              [ngTemplateOutlet]="smallBox"
              [ngTemplateOutletContext]="{ title: item.date, content: item.cities }"
            ></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-container>

<ng-template #bigBox let-boxTitle="boxTitle" let-boxSubtitle="boxSubtitle" let-boxPhone="boxPhone">
  <div class="box big">
    <div class="mask">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none">
        <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="357" height="343">
          <rect width="357" height="343" rx="15" fill="#B54A17" />
        </mask>
        <g mask="url(#mask0)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M768.754 211.425C776.151 271.968 776.973 335.099 742.605 382.816C726.565 405.077 706.29 420.893 685.787 435.222C670.702 445.766 655.124 454.659 643.858 471.944C633.42 487.948 625.485 506.531 615.408 522.954C602.114 544.718 586.208 563.559 568.3 578.752C523.412 616.763 468.807 634.541 416.566 640.708C391.277 643.705 363.845 645.265 338.727 637.095C314.468 629.212 290.482 616.746 268.177 602.212C220.76 571.345 179.665 526.14 149.875 468.988C129.447 429.786 118.402 391.668 144.855 351.9C174.677 307.073 221.436 282.34 259.977 253.246C286.41 233.292 316.036 213.732 320.974 171.328C324.906 137.586 328.099 105.561 338.271 73.6677C353.411 26.624 375.672 -15.9909 403.732 -51.6487C429.394 -84.1335 461.859 -111.7 498.566 -94.3487C527.648 -80.5779 550.212 -49.7272 575.622 -27.6709C603.939 -3.03631 635.051 10.5456 667.813 21.4669C697.256 31.3208 724.979 46.4629 744.009 78.6111C747.903 85.1803 751.994 92.3326 754.997 99.6819C758.828 109.059 758.531 118.355 759.283 128.866C761.243 156.604 765.409 184.023 768.754 211.425Z"
            stroke="#DFEAF9"
            stroke-width="2"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M-694.595 -640.802C-709.384 -670.599 -735.33 -692.624 -756.869 -713.351C-787.863 -743.19 -819.832 -771.37 -851.32 -800.364C-881.094 -827.781 -910.931 -855.51 -938.503 -886.646C-955.316 -905.633 -976.412 -928.339 -984.375 -956.421C-1001.65 -1017.29 -908.717 -1008.05 -885.774 -1009.65C-828.738 -1013.59 -764.073 -1014.49 -711.306 -1046.54C-678.357 -1066.55 -664.821 -1099.74 -671.848 -1145.81C-674.277 -1161.75 -678.655 -1175.37 -673.114 -1191.22C-666.706 -1209.58 -651.968 -1221.02 -638.456 -1229.1C-596.133 -1254.41 -546.105 -1259.78 -500.227 -1264.26C-452.83 -1268.88 -403.448 -1272.14 -357.576 -1268.76C-339.232 -1267.41 -318.118 -1275.05 -299.964 -1280.91C-272.031 -1289.94 -244.382 -1300.36 -216.588 -1310.05C-160.102 -1329.75 -102.149 -1348.73 -43.3854 -1350.89C-0.960737 -1352.44 43.273 -1343.99 78.5689 -1311.31C114.339 -1278.17 130.21 -1226.8 150.046 -1177.97C184.305 -1093.54 230.575 -990.889 309.833 -973.052C321.851 -970.343 333.401 -971.812 345.407 -971.147C351.581 -970.811 358.608 -969.744 361.739 -961.839C369.868 -941.317 347.596 -903.794 340.1 -888.074C319.391 -844.634 296.107 -803.319 274.404 -760.715C257.167 -726.887 235.319 -689.299 228.652 -649.199C220.562 -600.538 273.424 -565.913 292.014 -531.65C324.242 -472.234 263.183 -438.381 233.08 -410.053C198.512 -377.53 169.978 -318.197 200.966 -267.877C212.82 -248.636 227.406 -237.168 232.701 -212.057C240.981 -172.787 234.718 -127.909 228.001 -89.09C217.88 -30.7338 201.864 26.9903 180.092 79.7317C164.494 117.492 138.616 176.702 100.721 172.261C75.2101 169.298 49.2758 158.47 24.4359 148.899C-12.7577 134.574 -49.4831 118.247 -86.0125 101.288C-170.337 62.247 -253.731 19.2002 -335.487 -28.148C-391.271 -60.466 -546.877 -192.537 -558.585 -197.249C-593.495 -211.286 -633.187 -208.815 -669.179 -206.64C-717.056 -203.75 -764.693 -196.264 -812.292 -189.327C-834.95 -186.044 -857.721 -182.03 -880.499 -180.413C-896.711 -179.263 -918.003 -178.278 -932.203 -190.518C-959.921 -214.397 -929.04 -269.035 -916.269 -292.15C-877.147 -363.017 -827.656 -424.386 -781.253 -487.133C-758.482 -517.941 -735.362 -548.699 -714.691 -581.978C-706.354 -595.415 -685.454 -622.398 -694.595 -640.802Z"
            stroke="#DFEAF9"
            stroke-width="2"
          />
        </g>
      </svg>
    </div>

    <i class="fas fa-home"></i>
    <span class="title">
      {{ boxTitle }}
    </span>
    <span class="text">
      {{ boxSubtitle }}
    </span>
    <span class="phone">
      <i class="fas fa-phone"></i>
      {{ boxPhone }}
    </span>
  </div>
</ng-template>

<ng-template #smallBox let-title="title" let-content="content">
  <div class="box small">
    <div class="title">{{ title }}</div>
    <div class="text">{{ content }}</div>
  </div>
</ng-template>
